<script setup lang="ts">
import { useAppStore } from '@/store/app/app'
import { useToggleStore } from '@/store/toggle/toggle'

import { AsyncDataKey } from '@/types/main'

const { data: simpleCategories } = useNuxtData(AsyncDataKey.SIMLE_CATEGORIES)

const appStore = useAppStore()
const { isLandingPageEnabled } = useToggleStore()

const isScrollTriggerActive = computed(() => {
  return isLandingPageEnabled && appStore.activeCategorySlug
})

const handleClick = (categorySlug: string) => {
  appStore.goToCategory(categorySlug)
}
</script>

<template>
  <div class="menu-categories">
    <the-slider
      overlay="sm"
      :space-between="32"
      :slide-width="80"
      :ripple="false"
      :scroll-trigger="isScrollTriggerActive ? appStore.activeCategorySlug : ''"
      slide-class="menu-categories__link"
      slide-active-class="menu-categories__link--active"
      is-different-width
    >
      <a
        v-for="(category, index) in simpleCategories"
        :key="index"
        :class="{
          'menu-categories__link--active':
            category.slug === appStore.activeCategorySlug,
        }"
        class="menu-categories__link"
        @click.prevent="handleClick(category.slug)"
      >
        {{ category.name }}
      </a>
    </the-slider>
  </div>
</template>

<style lang="scss" scoped>
.menu-categories {
  height: 100%;
  padding: 4px 24px;

  @include media('>=desktop') {
    max-width: 1200px;
    padding: 4px 0;
    margin: 0 auto;
  }

  &__link {
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    color: var(--ui-text-primary);
    cursor: pointer;

    &--active {
      color: var(--ui-primary);
    }
  }
}
</style>
